import firebase from './firebase';

class Analytics {
  logPageViewEvent(pageName, parameters) {
    this.logEvent('page_view', {
      page_name: pageName,
      ...parameters,
    });
  }

  logEvent(name, parameters) {
    firebase.analytics.logEvent(name, {
      site: 'patient-booking',
      ...parameters,
    });
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      console.log('Event Tracking: ', name, {
        site: 'patient-booking',
        ...parameters,
      });
    }
  }
}

const analytics = new Analytics();
export default analytics;
